import { DrawerActions } from "../reducers/drawer";

export const { toggleDrawer } = DrawerActions;
